import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_VIEWED_SCHOOL_PORTRAITS_BY_CLASS_ID = gql`
  query GetViewedSchoolPortraits($classId: Int!) {
    getViewedSchoolPortaits(schoolClassID: $classId) {
      id
      title
      visits
      image {
        ...imageFields
      }
    }
  }
  ${ImageFragment}
`;
